// La empresa del usuario, recordada para TODA la pestaña —
// ADR-2026-09-08-la-portada-no-parpadea-mientras-se-resuelve-la-empresa.
//
// Cada pantalla resuelve su `id_company` con `auth.getUser()` + una consulta a `profiles`
// al montar. Son unos cientos de ms por montaje, y en ese hueco la columna de resultados
// no sabe de quién son las tandas: dibuja esqueletos en lugar de lo que se está
// generando. Como el id no cambia mientras dure la sesión, alcanza con recordarlo la
// primera vez que alguien lo averigua.
//
// Vive en el cache de sesión y no en un `let` de módulo por UNA razón: ese cache se vacía
// cuando cambia el dueño de la sesión (`setCacheOwner`, ADR-2026-08-20-el-cache-de-sesion-cruzaba-cuentas),
// que es exactamente lo que tiene que pasarle a un `id_company` cuando se entra con otra
// cuenta sin recargar la página. Un `let` sobreviviría a ese cambio y le serviría la
// empresa anterior a la cuenta nueva.
//
// El TTL de 12h lo distingue de `CACHE_KEYS.USER_PROFILE`, que dura 5 minutos: ese TTL
// corto está bien para un perfil que puede cambiar (nombre, email), pero acá lo que se
// quiere es "el mismo id mientras esta pestaña siga siendo de esta cuenta" — y con 5
// minutos, cualquier sesión de trabajo normal volvía a quedarse sin dato.

import { getCached, setCached } from '../../utils/sessionCache';

/** Clave propia: no pisa ni depende del perfil cacheado. */
const CLAVE = 'company:id-de-la-sesion';

/** Prácticamente "lo que dure la pestaña", sin ser infinito. */
const TTL_MS = 12 * 60 * 60 * 1000;

/**
 * Deja anotado el `id_company` que se acaba de resolver.
 *
 * `owner` es el `user.id` que el llamador tomó ANTES de su `await` — el mismo contrato
 * que `setCached`: firmar con el dueño de ahora no protege de nada, porque entre la
 * consulta y la respuesta la sesión puede haber cambiado de cuenta.
 */
export function recordarEmpresa(
  idCompany: string | null | undefined,
  owner: string | null,
): void {
  if (!idCompany) return;
  setCached(CLAVE, idCompany, owner, TTL_MS);
}

/** El `id_company` de esta sesión si alguien ya lo averiguó; `null` si no. Síncrono. */
export function empresaRecordada(): string | null {
  return getCached<string>(CLAVE);
}
